import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { setupSardine } from '@sardine-ai/web-sdk';
import ReactRailsUJS from 'react_ujs';

const signupsComponentRequireContext = require.context('../', true, /^\.\/react\/(signups|shared)/);

require('global_exports.js');

/* eslint-disable-next-line react-hooks/rules-of-hooks */
ReactRailsUJS.useContext(signupsComponentRequireContext);

require('i18n-translations.js.erb');

// Signup: Configure Sardine
document.addEventListener('DOMContentLoaded', () => {
  if (window.sardineConfig) {
    setupSardine({
      clientId: window.sardineConfig.clientId,
    });
  }
});
